export default __webpack_public_path__ + "c5d36652659e27a23932f61f53df4429.png";